const Play = "Play";
const Pause = "Pause";
const Replay = "Replay";
const Duration = "Duration";
const LIVE = "LIVE";
const Loaded = "Loaded";
const Progress = "Progress";
const Fullscreen = "Fullscreen";
const Mute = "Mute";
const Unmute = "Unmute";
const Subtitles = "Subtitles";
const Captions = "Captions";
const Chapters = "Chapters";
const Descriptions = "Descriptions";
const Close = "Close";
const Text = "Text";
const White = "White";
const Black = "Black";
const Red = "Red";
const Green = "Green";
const Blue = "Blue";
const Yellow = "Yellow";
const Magenta = "Magenta";
const Cyan = "Cyan";
const Background = "Background";
const Window = "Window";
const Transparent = "Transparent";
const Opaque = "Opaque";
const None = "None";
const Raised = "Raised";
const Depressed = "Depressed";
const Uniform = "Uniform";
const Casual = "Casual";
const Script = "Script";
const Reset = "Reset";
const Done = "Done";
const Color = "Color";
const Opacity = "Opacity";
const en = {
	"Audio Player": "Audio Player",
	"Video Player": "Video Player",
	Play: Play,
	Pause: Pause,
	Replay: Replay,
	"Current Time": "Current Time",
	Duration: Duration,
	"Remaining Time": "Remaining Time",
	"Stream Type": "Stream Type",
	LIVE: LIVE,
	"Seek to live, currently behind live": "Seek to live, currently behind live",
	"Seek to live, currently playing live": "Seek to live, currently playing live",
	Loaded: Loaded,
	Progress: Progress,
	"Progress Bar": "Progress Bar",
	"progress bar timing: currentTime={1} duration={2}": "{1} of {2}",
	Fullscreen: Fullscreen,
	"Exit Fullscreen": "Exit Fullscreen",
	Mute: Mute,
	Unmute: Unmute,
	"Playback Rate": "Playback Rate",
	Subtitles: Subtitles,
	"subtitles off": "subtitles off",
	Captions: Captions,
	"captions off": "captions off",
	Chapters: Chapters,
	Descriptions: Descriptions,
	"descriptions off": "descriptions off",
	"Audio Track": "Audio Track",
	"Volume Level": "Volume Level",
	"You aborted the media playback": "You aborted the media playback",
	"A network error caused the media download to fail part-way.": "A network error caused the media download to fail part-way.",
	"The media could not be loaded, either because the server or network failed or because the format is not supported.": "The media could not be loaded, either because the server or network failed or because the format is not supported.",
	"The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
	"No compatible source was found for this media.": "No compatible source was found for this media.",
	"The media is encrypted and we do not have the keys to decrypt it.": "The media is encrypted and we do not have the keys to decrypt it.",
	"Play Video": "Play Video",
	Close: Close,
	"Close Modal Dialog": "Close Modal Dialog",
	"Modal Window": "Modal Window",
	"This is a modal window": "This is a modal window",
	"This modal can be closed by pressing the Escape key or activating the close button.": "This modal can be closed by pressing the Escape key or activating the close button.",
	", opens captions settings dialog": ", opens captions settings dialog",
	", opens subtitles settings dialog": ", opens subtitles settings dialog",
	", opens descriptions settings dialog": ", opens descriptions settings dialog",
	", selected": ", selected",
	"captions settings": "captions settings",
	"subtitles settings": "subtitles settings",
	"descriptions settings": "descriptions settings",
	Text: Text,
	White: White,
	Black: Black,
	Red: Red,
	Green: Green,
	Blue: Blue,
	Yellow: Yellow,
	Magenta: Magenta,
	Cyan: Cyan,
	Background: Background,
	Window: Window,
	Transparent: Transparent,
	"Semi-Transparent": "Semi-Transparent",
	Opaque: Opaque,
	"Font Size": "Font Size",
	"Text Edge Style": "Text Edge Style",
	None: None,
	Raised: Raised,
	Depressed: Depressed,
	Uniform: Uniform,
	"Drop shadow": "Drop shadow",
	"Font Family": "Font Family",
	"Proportional Sans-Serif": "Proportional Sans-Serif",
	"Monospace Sans-Serif": "Monospace Sans-Serif",
	"Proportional Serif": "Proportional Serif",
	"Monospace Serif": "Monospace Serif",
	Casual: Casual,
	Script: Script,
	"Small Caps": "Small Caps",
	Reset: Reset,
	"restore all settings to the default values": "restore all settings to the default values",
	Done: Done,
	"Caption Settings Dialog": "Caption Settings Dialog",
	"Beginning of dialog window. Escape will cancel and close the window.": "Beginning of dialog window. Escape will cancel and close the window.",
	"End of dialog window.": "End of dialog window.",
	"{1} is loading.": "{1} is loading.",
	"Exit Picture-in-Picture": "Exit Picture-in-Picture",
	"Picture-in-Picture": "Picture-in-Picture",
	"No content": "No content",
	Color: Color,
	Opacity: Opacity,
	"Text Background": "Text Background",
	"Caption Area Background": "Caption Area Background",
	"Playing in Picture-in-Picture": "Playing in Picture-in-Picture",
	"Skip backward {1} seconds": "Skip backward {1} seconds",
	"Skip forward {1} seconds": "Skip forward {1} seconds"
};

const videoPlayerLocale = /*#__PURE__*/Object.freeze(/*#__PURE__*/Object.defineProperty({
  __proto__: null,
  Background,
  Black,
  Blue,
  Captions,
  Casual,
  Chapters,
  Close,
  Color,
  Cyan,
  Depressed,
  Descriptions,
  Done,
  Duration,
  Fullscreen,
  Green,
  LIVE,
  Loaded,
  Magenta,
  Mute,
  None,
  Opacity,
  Opaque,
  Pause,
  Play,
  Progress,
  Raised,
  Red,
  Replay,
  Reset,
  Script,
  Subtitles,
  Text,
  Transparent,
  Uniform,
  Unmute,
  White,
  Window,
  Yellow,
  default: en
}, Symbol.toStringTag, { value: 'Module' }));

const enUS = {
  lang: "en-US",
  common: {
    useCommaAsDecimalSeparator: false
  },
  pickerField: {
    clearLabel: "Clear",
    okLabel: "OK"
  },
  calendarPicker: {
    months: {
      name: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      shorthand: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ]
    },
    weekdays: {
      name: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
    },
    firstDayOfWeek: 0,
    dateFormat: "MM/dd/yyyy",
    dateFormatPlaceholder: "MM/DD/YYYY",
    chooseDateLabel: "Choose date",
    changeDateLabel: (
      /* istanbul ignore next */
      (date) => `Change date, ${date}`
    ),
    chooseDatesLabel: "Choose dates",
    changeDatesLabel: (
      /* istanbul ignore next */
      (range) => `Change dates, ${range}`
    ),
    prevYearLabel: "Previous year",
    prevMonthLabel: "Previous month",
    nextMonthLabel: "Next month",
    nextYearLabel: "Next year",
    todayLabel: "today",
    selectedLabel: "selected",
    currentLabel: "current",
    changeMonthLabel: (
      /* istanbul ignore next */
      (month) => `Change month, ${month} selected`
    ),
    showCalendarForMonthLabel: (
      /* istanbul ignore next */
      (month) => `Show calendar for ${month}`
    ),
    invalidDateError: "Please enter a valid date.",
    invalidDateRangeError: "Please enter a valid date range.",
    startDateAfterMinDateError: (
      /* istanbul ignore next */
      (minDate) => `The start date must be ${minDate} or later.`
    ),
    endDateBeforeMaxDateError: (
      /* istanbul ignore next */
      (maxDate) => `The end date must be ${maxDate} or earlier.`
    )
  },
  timePicker: {
    defaultTo12HourClock: true,
    chooseTimeLabel: "Choose time",
    changeTimeLabel: (
      /* istanbul ignore next */
      (time) => `Change time, ${time}`
    ),
    hoursLabel: "hours",
    minutesLabel: "minutes",
    secondsLabel: "seconds",
    meridiesLabel: "AM/PM",
    invalidTimeError: "Please enter a valid time."
  },
  dateTimePicker: {
    chooseDateTimeLabel: "Choose date and time",
    changeDateTimeLabel: (
      /* istanbul ignore next */
      (dateTime) => `Change date and time, ${dateTime}`
    ),
    invalidDateTimeError: "Please enter a valid date and time.",
    dateBeforeMinDateError: (
      /* istanbul ignore next */
      (minDate) => `Date must be ${minDate} or later.`
    ),
    dateAfterMaxDateError: (
      /* istanbul ignore next */
      (maxDate) => `Date must be ${maxDate} or earlier.`
    ),
    timeBeforeMinTimeError: (
      /* istanbul ignore next */
      (minTime) => `Time must be ${minTime} or later.`
    ),
    timeAfterMaxTimeError: (
      /* istanbul ignore next */
      (maxTime) => `Time must be ${maxTime} or earlier.`
    )
  },
  filePicker: {
    invalidFileTypeError: "You can't select files of this type.",
    maxFilesExceededError: "You can't select any more files.",
    fileTooBigError: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
    removeFileLabel: "Remove file",
    invalidFilesError: "One or more selected files are invalid. Please, upload only valid file types under the size limit."
  },
  audioPlayer: {
    playButtonLabel: "Play",
    pauseButtonLabel: "Pause",
    sliderLabel: "Audio progress bar",
    skipForwardButton: "Skip Forward",
    skipBackwardButton: "Skip Backward"
  },
  alert: {
    dismissButtonLabel: "Close"
  },
  dialog: {
    dismissButtonLabel: "Close"
  },
  banner: {
    dismissButtonLabel: "Close"
  },
  numberField: {
    incrementButtonLabel: (
      /* istanbul ignore next */
      (step) => step === 1 ? "Increase value" : `Increase value by ${step}`
    ),
    decrementButtonLabel: (
      /* istanbul ignore next */
      (step) => step === 1 ? "Decrease value" : `Decrease value by ${step}`
    ),
    updatedValueAnnouncement: (
      /* istanbul ignore next */
      (value) => `Updated value: ${value}`
    )
  },
  splitButton: {
    showMoreActionsLabel: "Show more actions"
  },
  videoPlayer: videoPlayerLocale,
  rangeSlider: {
    startThumbLabel: "min",
    endThumbLabel: "max"
  },
  dialPad: {
    inputLabel: "Phone number",
    deleteButtonLabel: "Delete last digit",
    callButtonLabel: "Call",
    endCallButtonLabel: "End call",
    digitOneLabel: "1",
    digitTwoLabel: "2 ABC",
    digitThreeLabel: "3 DEF",
    digitFourLabel: "4 GHI",
    digitFiveLabel: "5 JKL",
    digitSixLabel: "6 MNO",
    digitSevenLabel: "7 PQRS",
    digitEightLabel: "8 TUV",
    digitNineLabel: "9 WXYZ",
    digitAsteriskLabel: "*",
    digitZeroLabel: "0",
    digitHashtagLabel: "#"
  },
  tab: {
    dismissButtonLabel: "Press the DELETE key to close this tab"
  },
  searchableSelect: {
    clearButtonLabel: "Clear selection",
    noOptionsMessage: "No options",
    noMatchesMessage: "No options found",
    loadingOptionsMessage: "Loading...",
    removeTagButtonLabel: (
      /* istanbul ignore next */
      (label) => `Remove ${label}`
    ),
    optionSelectedMessage: (
      /* istanbul ignore next */
      (name) => `Option ${name} selected.`
    ),
    optionDeselectedMessage: (
      /* istanbul ignore next */
      (name) => `Option ${name} deselected.`
    ),
    optionFocusedMessage: (
      /* istanbul ignore next */
      (name, position, total, selected) => `Option ${name} focused, ${selected ? "selected, " : ""}${position} of ${total}.`
    ),
    maxSelectedMessage: (
      /* istanbul ignore next */
      (total, limit) => `${total} of ${limit} selected.`
    )
  },
  richTextEditor: {
    textBlockType: "Text Block Type",
    textSize: "Text Size",
    bold: "Bold",
    italics: "Italics",
    underline: "Underline",
    strikethrough: "Strikethrough",
    monospace: "Monospace",
    dragAndDropFilesHere: "Drag&Drop files here"
  },
  button: {
    pendingLabel: "Loading..."
  },
  feedbackMessage: {
    errorIconText: "Error:",
    successIconText: "Success:"
  },
  connotationAnnoncement: {
    accentIcon: "Accent:",
    alertIcon: "Alert:",
    informationIcon: "Information:",
    successIcon: "Success:",
    warningIcon: "Warning:",
    announcementIcon: "Announcement:",
    ctaIcon: "Call to action:"
  },
  charCount: {
    charactersLimitMessage: (
      /* istanbul ignore next */
      (limit) => `You can enter up to ${limit} characters`
    ),
    charactersRemainingMessage: (
      /* istanbul ignore next */
      (total) => `You have ${total} characters remaining`
    )
  },
  dataGrid: {
    cell: {
      selected: "Selected",
      button: "(button)"
    }
  },
  pagination: {
    previousPageLabel: "Go to previous page",
    nextPageLabel: "Go to next page",
    goToPageLabel: (
      /* istanbul ignore next */
      (index) => `Go to page ${index}`
    )
  },
  tag: {
    remove: (
      /* istanbul ignore next */
      (label) => `Remove ${label}`
    )
  }
};

export { enUS as default };
